import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({
    providedIn: 'root'
})
export class SaPickingNotValidatedMessageService extends ApiService {

    select(params: any = {}) {
        return super.get(`/sa-picking-not-validated-messages/select`, params);
    }
}
